export default "__VITE_ASSET__ca9f6c89__"